module.exports = __webpack_public_path__ + "img/share_qr_invi.d7629a37.png";